import { RoleModel, TenantSettingsUsersList, TenantUsersList } from '@/models/role-permission/role-permission';

export class RoleAndPermissionSerializer {

    private static INSTANCE = new RoleAndPermissionSerializer();

    static get instance() {
        return this.INSTANCE;
    }


    public normalizeUserList(payload: any) {
        const users = payload.users ? payload.users : [];
        const usersList: TenantUsersList[] = [];

        users.forEach((user: any) => {
            const userDetails: TenantUsersList = {
                id: user.id,
                firstName: user.firstName,
                lastName: user.lastName,
                name: `${user.firstName} ${user.lastName}`,
                displayName: user.displayName,
                email: user.email,
                status: user.status,
                thumbnail: user.thumbnail,
                roleId: user.roleId || null,
                roles: user.roles,
            };
            usersList.push(userDetails);
        });
        return usersList;
    }


    public normalizeSettingsUserList(payload: any) {
        const users = payload.userList ? payload.userList : [];
        const usersList: TenantSettingsUsersList[] = [];
        users.forEach((user: any) => {
            const userDetails: TenantSettingsUsersList = {
                id: user.id,
                firstName: user.firstName,
                lastName: user.lastName,
                name: `${user.firstName} ${user.lastName}`,
                displayName: user.displayName,
                userName: user.displayName,
                email: user.email,
                designation: user.designation,
                roleOriginal: user.roles,
                roles: this.getRolesIds(user.roles),
                rolesName: [],
                rolesCode: this.getRolesCodes(user.roles),
                group_school_id: user.groupSchoolId,
            };
            usersList.push(userDetails);
        });
        return usersList;
    }

    public normalizeRoleList(payload: any) {
        const roles = payload.roles ? payload.roles : [];
        const roleList: RoleModel[] = [];
        roles.forEach((item: any) => {
            const role: RoleModel = {
                id: item.id,
                displayName: item.displayName,
                code: item.code,
                description: item.description,
            };
            roleList.push(role);
        });
        return roleList;
    }

    private getRolesIds(roles: any) {
        const rolesList: any = [];
        for (const iterator of roles) {
            const role = parseInt(iterator.roleId, 10);
            rolesList.push(role);
        }

        return rolesList;
    }

    private getRolesCodes(roles: any) {
        const rolesList: any = [];
        for (const iterator of roles) {
            const role = parseInt(iterator.roleId, 10);
            rolesList.push(role);
        }

        return rolesList;
    }

}

export const roleAndPermissionSerializer = RoleAndPermissionSerializer.instance;
